<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('out_of_country_requests')"
                        @filter-div-status="datatable.filterStatus = $event">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('out_of_country_requests')"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
            >
                <b-row>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input size="sm"
                                          v-model="datatable.queryParams.filter.student_number"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('name')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.name"
                                         ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('surname')">
                            <b-form-input size="sm" v-model="datatable.queryParams.filter.surname"
                                         ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" xl="3">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox code="student_out_of_country_request_status" v-model="datatable.queryParams.filter.status"></parameter-selectbox>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            >
            </datatable>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from "@/layouts/AppLayout.vue";
    import Header from "@/layouts/AppLayout/Header.vue"
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue"
    //Component
    import DatatableFilter from "@/components/datatable/DatatableFilter.vue";
    import Datatable from "@/components/datatable/Datatable.vue";
    import CommonModal from "@/components/elements/CommonModal.vue";
    //Other
    import qs from "qs";
    //Service
    import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
    import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
    import OutOfCountryMentora from "@/services/OutOfCountryMentoraServices";


    export default {
        components: {
            ModuleDateSelectbox,
            AcademicYearsSelectbox,
            AppLayout,
            Header,
            HeaderMobile,
            DatatableFilter,
            Datatable,
            CommonModal,
        },
        metaInfo() {
            return {
                title: this.$t("mentora_time_of_requests"),
            };
        },
        computed:{
            userRoles(){
                return   this.$store.getters['auth/getActiveRole']
            },
        },
        data() {
            return {
                formId: 0,
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: "",
                            field: "buttons",
                            html: true,
                            sortable: false,
                            tdClass: "p-0 text-center w-40 align-middle",
                            buttons: [
                                {
                                    text: this.$t("detail"),
                                    class: "ri-edit-box-line",
                                    permission: 'studentoutofcountryrequest_show',
                                    callback: (row) => {
                                        this.$router.push('/mentora/out/of/country/request-detail/' + row.id)
                                    },
                                },
                                {
                                    text: this.$t('delete'),
                                    class: 'ri-delete-bin-2-line',
                                    permission:'studentoutofcountryrequest_delete',
                                    callback: (row) => {
                                        this.deleteRequests(row.id);
                                    }
                                },
                            ],
                        },
                        {
                            label: this.$t("student_id"),
                            field: "student_number",
                            sortable: false,
                        },
                        {
                            label: this.$t("name"),
                            field: "name",
                            sortable: true,
                        },
                        {
                            label: this.$t("surname"),
                            field: "surname",
                            sortable: true,
                        },
                        {
                            label: this.$t("estimated_date_of_departure"),
                            field: "estimated_departure_date",
                            sortable: true,
                        },
                        {
                            label: this.$t("estimated_date_of_return"),
                            field: "estimated_return_date",
                            sortable: true,
                        },
                        {
                            label: this.$t("module_status"),
                            field: "module_status",
                            sortable: true,
                        },

                        {
                            label: this.$t("good_standing"),
                            field: "good_standing",
                            formatFn: (value, row) => {
                                    return value==='No'?`<span class="badge badge-danger">${this.$t('no')}</span>`:`<span class="badge badge-success">${this.$t('yes')}</span>`
                            }
                        },
                        {
                            label: this.$t("status"),
                            field: "status_name",
                            sortable: false,
                        },
                        {
                            label: this.$t("step"),
                            field: "active_step.name",
                            sortable: false,
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        filter: {},
                        sort: "id",
                        page: 1,
                        limit: 20,
                    },
                },
            };
        },
        methods: {
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == "desc" ? "-" : "";
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams,
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false}),
                };

                return OutOfCountryMentora.getAll(config)
                                           .then((response) => {
                                               this.datatable.rows = response.data.data;
                                               this.datatable.total = response.data.pagination.total;
                                           })
                                           .finally(() => {
                                               this.datatable.isLoading = false;
                                           });
            },

            deleteRequests(id){
                this.deleteModal(() => {
                    OutOfCountryMentora.del(id)
                        .then(response => {
                            this.getRows();
                            this.$toast.success(this.$t('api.' + response.data.message));
                        })
                        .catch(error => {
                            this.$toast.error(this.$t('api.' + error.data.message));
                        });
                });
            },


            showForm(id) {
                this.formId = id
                this.formProcess = 'show'
                this.$refs.showModal.$refs.commonModal.show()
            },
        },
    };
</script>

